import { render, staticRenderFns } from "./ArticleHeadlinesSection.vue?vue&type=template&id=68f79eab&scoped=true&"
import script from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleHeadlinesSection.vue?vue&type=style&index=0&id=68f79eab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f79eab",
  null
  
)

export default component.exports